import {Button, Image, Input, Toast} from "antd-mobile";
import {useState} from "react";
import {TOASTDURATION} from "../../common/Utils";
import {opayCashierCreate} from "../../common/ApiAction";

const OpayPay = () => {
    const [accountNumber, setAccountNumber] = useState<string>('')
    const [amount, setAmount] = useState<string>('')
    const [payRemark, setPayRemark] = useState<string>('')

    const submitAction = () => {
        if (!accountNumber) {
            Toast.show({content: "Please enter your phone number", duration: TOASTDURATION})
            return
        }
        if (!amount) {
            Toast.show({content: "Please enter the amount", duration: TOASTDURATION})
            return
        }
        Toast.show({icon: 'loading', content: 'Processing...', duration: 0})
        const data = {
            accountNumber,
            amount,
            payRemark: payRemark.trim()
        }
        opayCashierCreate(data).then((res: any) => {
            Toast.clear();
            if (!res.executed) {
                Toast.show({icon: 'fail', content: res.message || 'Payment failed', duration: TOASTDURATION})
            } else {
                if (res.data) {
                    window.open(res.data, '_blank', 'noopener,noreferrer');
                }
            }
        }).catch(err => {
            Toast.clear();
            Toast.show({icon: 'fail', content: err.message || 'Payment failed', duration: TOASTDURATION})
        })
    }

    return <div style={{width: '100%', display: "flex", flexDirection: "column", alignItems: "center"}}>
        <div>
            <Image src={require('../../assets/nga_logo.png')} style={{width: 100}}/>
        </div>
        <div style={{borderRadius: 8, padding: '30px 0 20px 0', border: "solid #1677ff 1px", width: '90%', marginTop: 15, display: "flex", flexDirection: "column", alignItems: "center"}}>
            <span style={{fontSize: 20, fontWeight: "bold", marginBottom: 20}}>Opay Payment</span>
            <div style={{display: "flex", flexDirection: "row", alignItems: "center", marginTop: 20, width: '90%'}}>
                <span style={{fontSize: 14, width: 90}}>Phone Number:</span>
                <Input value={accountNumber} onChange={val => setAccountNumber(val)} type={'number'} style={{"--font-size": '14px', flex: 1, border: "solid #cccccc 1px", borderRadius: 4}} placeholder={"e.g. 234xxxxxxxxx"}/>
            </div>
            <div style={{display: "flex", flexDirection: "row", alignItems: "center", marginTop: 20, width: '90%'}}>
                <span style={{fontSize: 14, width: 90}}>Amount (NGN):</span>
                <Input onChange={val => setAmount(val)} type={'number'} style={{"--font-size": '14px', flex: 1, border: "solid #cccccc 1px", borderRadius: 4}} placeholder={"Enter amount"}/>
            </div>
            <div style={{display: "flex", flexDirection: "row", alignItems: "center", marginTop: 20, width: '90%'}}>
                <span style={{fontSize: 14, width: 90}}>Identifier No.:</span>
                <Input value={payRemark} onChange={val => setPayRemark(val)} style={{"--font-size": '14px', flex: 1, border: "solid #cccccc 1px", borderRadius: 4}} placeholder={"Enter identifier number"}/>
            </div>
        </div>
        <div style={{marginTop: 30}}>
            <Button shape='rounded' style={{backgroundColor: '#1677ff', color: '#FFF', paddingLeft: 40, paddingRight: 40}} onClick={submitAction}>Confirm Payment</Button>
        </div>
    </div>
}
export default OpayPay
